// Require

const { id, log, head, delay } = require("../std/index")
const { findWidgetInstances } = require("../widgets/index")


//
// AutoGallery Controller
//
// Given a fadeshow and a seperate control widget, marry them together
//

module.exports = class AutoGalleryController {
  constructor($page, $$) {
    this.autoInterval = 5000;

    // Start
    this.running = true;

    // Widgets
    this.controls = head(findWidgetInstances($page, 'gallery-controls'));
    this.diagrams = head(findWidgetInstances($page, 'gallery-swapper'));

    // Bail if widgets were not found
    if (!this.diagrams) {
      return log("AutoGalleryController - can't find slides");
    }

    // Listeners
    if (this.controls) {
      this.controls.onSelect((ix) => {
        this.controls.setActive(ix);
        this.diagrams.set(ix);
        this.running = false;
      });
    }

    // Init
    if (this.diagrams.length() >= 2) {
      this.start();
    } else {
      log('AutoGalleryController::init - dont run auto-gallery (not enough slides)');
    }
  }

  proceed() {
    if (this.running) {
      this.diagrams.next();
      this.controls.setActive(this.diagrams.current);
    }
    if (this.running) {
      delay(this.autoInterval, this.proceed.bind(this));
    }
  }

  start() {
    this.running = true;
    delay(this.autoInterval, this.proceed.bind(this));
  }

  stop() {
    this.running = false;
  }
};
